import type { FaireProductEntity } from "../../entity_types/product";

export const p_rd3pw7jrvx: FaireProductEntity = {
  token: "p_rd3pw7jrvx",
  type: "product",
  name: "Rhodiola root, Cut and Sifted, Certified Organic",
  brandToken: "b_dowxrh2caf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a9b7fb1f9449e625f44dd13ad8030ed60f53b69afa0cc33a6260fe4f261b24a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cca109a85e8137503dae808af347dc8ce80691f9d1780137afd8dd5f27d89b67.png",
  ],
  priceDollars: 232,
  description:
    "\nCHINA. Rhodiola crenulata Root, Cut and Sifted, Certified Organic\n\n\nCommon names: Golden Root, Roseroot, King’s Crown, Orpin Rose, Aaron’s Rod, Arctic Root, Stonecrop, Hong Jing Tian\n\nFamily: Crassulaceae\n\nRhodiola is a perennial flowering plant that grows in the far northern reaches of Europe, North America, and Asia. It is found in the wild in mountainous areas and on sea cliffs. The roots and bitter leaves can be eaten, either raw or cooked, and Rhodiola extract is sometimes used to flavor vodka. The Inupiat and Nunivak tribes also used Rhodiola flowers as a remedy for abdominal pain and tuberculosis.\n\nScandinavian and Russian people have long valued Rhodiola Root as an adaptogen, helpful for coping with the frigid climate and difficult life.",
  tags: [],
  msrpDollars: 464,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:24.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
